import { useCallback } from "react";

const LOCATION_ERROR_MESSAGE =
  "GPS nicht verfügbar oder Zugriff verweigert.";

export default function useGeolocation() {
  const getCurrentPosition = useCallback((onSuccess, onError) => {
    if (!navigator?.geolocation?.getCurrentPosition) {
      if (typeof onError === "function") {
        onError(new Error(LOCATION_ERROR_MESSAGE));
      }
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        if (typeof onSuccess === "function") {
          onSuccess(position);
        }
      },
      (error) => {
        if (typeof onError === "function") {
          onError(error);
        }
      },
    );
  }, []);

  return {
    getCurrentPosition,
    locationErrorMessage: LOCATION_ERROR_MESSAGE,
  };
}
